export default "__VITE_ASSET__DlNLTQZO__"